import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { configuration, setupAirbrake, dataLayer, privacy, authentication, api } from '@dpgradio/creative'
import { Notifier as AirbrakeNotifier } from '@airbrake/browser'
import { observeScreenSize } from './utils/screensizeObserver.js'
import { CAMPAIGN_CONFIG, IS_STAGING } from './config.js'
import './style.css'
import App from './App.vue'

const initialize = async () => {
  const params = new URLSearchParams(document.location.search)

  const station = params.get('station') || CAMPAIGN_CONFIG.station
  if (!station) {
    console.error('No station parameter provided in the URL.')
    return
  }

  await configuration.retrieveConfigForStation(station)

  if (IS_STAGING) {
    const currentBaseUrl = api.baseUrl
    api.baseUrlOverride = currentBaseUrl.replace('api.', 'api.stag.')
  }

  authentication.initialize()

  const pinia = createPinia()
  const app = createApp(App)

  if (import.meta.env.PROD) {
    await setupAirbrake(
      AirbrakeNotifier,
      {
        projectId: 635045,
        projectKey: '9ce1e380125ac4ef7234f3b107463ed0',
        version: import.meta.env.VITE_COMMIT_HASH,
      },
      app
    )
  }

  app.use(pinia)
  app.mount('#app')

  privacy.initialize()
  dataLayer.initialize()
  dataLayer.setCampaignDetails({
    brand: configuration.stationId,
    signupRequired: true,
    title: CAMPAIGN_CONFIG.dataLayer.title,
    type: CAMPAIGN_CONFIG.dataLayer.type,
  })
  dataLayer.pushVirtualPageView()

  observeScreenSize()
}

initialize()
